exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n@media screen and (weex-theme: colmo) {\n.text[data-v-95fb6ed8] {\n    font-family: PingFangSC-Medium;\n    font-size: 0.48rem;\n    line-height: 0.48rem;\n    color: #1E2E37;\n    letter-spacing: 0;\n    font-weight: 500;\n}\n}\n", "", {"version":3,"sources":["/Users/wuhm45/Documents/code/weex组件库/dolphin-weex-ui/packages/dof-catalog/colmo.css"],"names":[],"mappings":";AAAA;AACE;IACE,+BAA+B;IAC/B,mBAAgB;IAChB,qBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,iBAAiB;CAClB;CACF","file":"colmo.css","sourcesContent":["@media screen and (weex-theme: colmo) {\n  .text {\n    font-family: PingFangSC-Medium;\n    font-size: 36px;\n    line-height: 36px;\n    color: #1E2E37;\n    letter-spacing: 0;\n    font-weight: 500;\n  }\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-95fb6ed8","scoped":true,"hasInlineConfig":false}!./packages/dof-catalog/colmo.css
// module id = 248
// module chunks = 0 1